// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadHeroCard-cls1_kVL","cls2":"DownloadHeroCard-cls2_LuB DownloadHeroCard-cls1_kVL"};